import { render, staticRenderFns } from "./payCost.vue?vue&type=template&id=b794ca6a&scoped=true"
import script from "./payCost.vue?vue&type=script&lang=js"
export * from "./payCost.vue?vue&type=script&lang=js"
import style0 from "./payCost.vue?vue&type=style&index=0&id=b794ca6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b794ca6a",
  null
  
)

export default component.exports